<header *ngIf="IsModal" class="modal-header-container flex align-items-center justify-content-between p-3 shadow-1">
	<h5 class="modal-title m-0 font-bold text-lg">
		<ng-container *ngIf="(orderType$ | async) == 'Pickup'">{{ translations['findRestaurant'] }}</ng-container>
		<ng-container *ngIf="(orderType$ | async) == 'Delivery'">{{ translations['deliveryAddress'] }}</ng-container>
	</h5>
	<button
		type="button"
		class="border-none bg-transparent cursor-pointer flex align-items-center hover:text-primary"
		(click)="closeModal()"
	>
		<app-icon iconName="x" class="text-2xl text-600" />
	</button>
</header>

<main class="stores-main-container w-full" [class.is-modal]="IsModal">
	<div class="grid h-full m-0 homepage-slider" [formGroup]="formGroup">
		<div [ngClass]="showMap ? 'col-12 md:col-5 lg:col-4' : 'col-12'" class="p-0 h-full stores-left-column">
			<app-scroll-container direction="vertical" size="auto" [showScrollable]="true">
				<div class="flex flex-column gap-3 p-4">
					<!-- Order method & location search -->
					<div class="flex flex-column">
						<span class="text-xl font-bold mb-3">{{ translations['selectOrderMethod'] }}</span>
						<app-switch-v2
							#switchHome
							[onLabel]="translations['delivery']"
							[offLabel]="translations['pickup']"
							(changed)="onSwitchChanged()"
						></app-switch-v2>
					</div>

					<app-adresses-locator
						#adressesLocator
						[mode]="AdressesLocatorModeEnum.SearchAndForm"
						[IsModal]="IsModal"
						[storeInDelivery]="storeInDelivery$ | async"
						(addressSelected)="onAddressSelected($event)"
					></app-adresses-locator>

					<div class="flex align-items-center my-2">
						<div class="flex-grow-1 divider-line"></div>
						<div class="px-3 font-bold text-sm">{{ translations['or'] }}</div>
						<div class="flex-grow-1 divider-line"></div>
					</div>

					<!-- Saved Addresses for Delivery -->
					<ng-container *ngIf="(orderType$ | async) == 'Delivery'">
						<app-adresses-locator
							[mode]="AdressesLocatorModeEnum.SavedAddresses"
							[IsModal]="IsModal"
							(addressSelected)="onSavedAddressSelected($event)"
						></app-adresses-locator>
					</ng-container>

					<!-- Stores List (Pickup and Delivery) -->
					<app-stores-list
						[storesWithDistance]="storesWithDistance$ | async"
						[storeInDelivery]="storeInDelivery$ | async"
						[orderType]="orderType$ | async"
						(storeSelected)="onStoreSelected($event)"
					></app-stores-list>
				</div>
			</app-scroll-container>
		</div>

		<!-- Right Column: Location Map -->
		<div *ngIf="showMap" class="col-12 md:col-7 lg:col-8 p-0 h-full hidden md:block">
			<app-location-map class="h-full w-full block" (addressSelected)="onMapAddressSelected($event)"></app-location-map>
		</div>
	</div>
</main>
